import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import { makeStyles, Theme } from '@material-ui/core'
import React, { useState } from 'react'
import { Collapse } from 'react-bootstrap'
interface CollapsibleTableContainerProps {
    children: HTMLDivElement
}

const useStyles = makeStyles((theme: Theme) => ({
    marginTopSpacing: {
        marginTop: theme.spacing(1.25),
    },
}))

export const CollapsibleTableContainer: React.FC<CollapsibleTableContainerProps> = ({
    children,
}) => {
    const classes = useStyles()
    const [isTableOpen, setIsTableOpen] = useState(false)
    return (
        <div className={classes.marginTopSpacing}>
            <RoundButton
                hasShadow={false}
                backgroundColor="#0098D6"
                onClick={() => setIsTableOpen(!isTableOpen)}
                aria-controls="collapsible-table-parent"
                aria-expanded={isTableOpen}
            >
                {isTableOpen ? 'Hide Data Table' : 'Show Data Table'}
            </RoundButton>
            <Collapse in={isTableOpen} className={classes.marginTopSpacing}>
                <div id="collapsible-table-parent">{children}</div>
            </Collapse>
        </div>
    )
}
